// ---------------------------------------------------------------------------
// Prezio Onboard Widget — URL Builders
// ---------------------------------------------------------------------------
// Helpers to construct API endpoint paths.
// Note: options URLs come from the API response (next_step.options_url) — never build them.
// ---------------------------------------------------------------------------

function base(baseUrl: string, sessionId: string): string {
  return `${baseUrl}/v1/onboard/sessions/${sessionId}`;
}

/** GET / PATCH — fetch or update the session. */
export function sessionUrl(baseUrl: string, sessionId: string): string {
  return `${base(baseUrl, sessionId)}/`;
}

/** POST — validate step data without persisting. */
export function validateUrl(baseUrl: string, sessionId: string): string {
  return `${base(baseUrl, sessionId)}/validate/`;
}

/** POST — apply and complete the session. */
export function completeUrl(baseUrl: string, sessionId: string): string {
  return `${base(baseUrl, sessionId)}/complete/`;
}

/** POST — cancel the session. */
export function cancelUrl(baseUrl: string, sessionId: string): string {
  return `${base(baseUrl, sessionId)}/cancel/`;
}

/** POST — go back to the previous step. */
export function backUrl(baseUrl: string, sessionId: string): string {
  return `${base(baseUrl, sessionId)}/back/`;
}

/** POST — navigate to a previously completed step (jump-to-edit). */
export function navigateUrl(baseUrl: string, sessionId: string): string {
  return `${base(baseUrl, sessionId)}/navigate/`;
}

/** GET — fetch options for a step. */
export function optionsUrl(baseUrl: string, sessionId: string, step: string): string {
  return `${base(baseUrl, sessionId)}/options/?step=${step}`;
}
